import { Component } from '@angular/core';

@Component({
  selector: 'app-api-documentation',
  imports: [],
  templateUrl: './api-documentation.component.html',
  styleUrl: './api-documentation.component.scss',
})
export class ApiDocumentationComponent {

}
